import { TiersSortableCols } from '@core-lib/enums';
import { ITiersList, ITiersPersonneMoraleForm, ITiersPersonnePhysiqueForm } from '@core-lib/models';
import { ModalRef } from '@core-lib/modules/modal-container';
import { IStoreDatagridStateSlice } from '../datagrid-slice.function';
import { IStoreEntityStateSlice, createEntitySlice } from '../entity-slice.function';

export interface ITiersStoreState {
	tiersForm: IStoreEntityStateSlice<ITiersPersonnePhysiqueForm | ITiersPersonneMoraleForm>;
	tiersFormModal: ModalRef['id'];
	tiersList: IStoreDatagridStateSlice<ITiersList, TiersSortableCols>;
	isSubmitButtonDisabled: boolean;
}

export const initialState: ITiersStoreState = {
	tiersForm: createEntitySlice(),
	tiersFormModal: null,
	tiersList: null,
	isSubmitButtonDisabled : false
};
